module.exports = __webpack_public_path__ + "static/media/HeadShot.6c98e8d2.png";